export function formatNumbers(value: number): string {
  return value !== undefined
    ? `${Number(value).toFixed(2)}`
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        .replace('.', ',')
    : ''
}
